// extracted by mini-css-extract-plugin
export default {"icon":"styles__icon__DijND","newBackground":"styles__newBackground__ZbSsx","storybookIcon":"styles__storybookIcon__pLqAg"};